'use client';

import { Hit as AlgoliaHit } from 'instantsearch.js/es/types';
import { memo } from 'react';
import { ArticleHit, ICaseStudyItem } from '@workspace/interfaces';
import { CaseStudyCard } from './CaseStudyCard';

interface CaseStudiesPageItemHitProps {
  hit: AlgoliaHit<ArticleHit>;
  className?: string;
}

function CaseStudiesPageItemHitInternal({ hit, className }: CaseStudiesPageItemHitProps) {
  const product: ICaseStudyItem = {
    _id: hit.objectID,
    name: hit.title || '',
    description: hit.content || '',
    image: {
      asset: {
        url: hit.thumbnailImage || '',
      },
    },
    slug: { current: hit.slug || '' },
    viewDetailLink: {
      type: 'internal',
      url: hit.url || '',
    },
    tags: hit.articleTags,
  };

  return <CaseStudyCard key={product._id} product={product} className={className} />;
}

export const CaseStudiesPageItemHit = memo(CaseStudiesPageItemHitInternal);
